import { useOnixCodetablesByNumbers, } from "../../api/onixService";
import { ONIX_TABLES } from "../../utils/onixTables";
import { toSelectOptions } from "../../utils/selectMappers";
var noop = function () { return undefined; };
/** Extracts the load state of a codetable query for the ONIX pickers. */
export var toCodetableStatus = function (query) {
    var _a;
    return ({
        isLoading: !!query.isLoading,
        isError: !!query.isError,
        refetch: (_a = query.refetch) !== null && _a !== void 0 ? _a : noop,
    });
};
/** Every ONIX codetable used by the title and product forms. */
var FORM_CODETABLE_NUMBERS = Object.values(ONIX_TABLES);
/**
 * Loads all ONIX codetables used by the title and product forms — together, in
 * one request. For every codetable `x` it exposes `xTable` (raw data),
 * `xOptions` (select options), `xLoading` and `xStatus` (loading/error state +
 * refetch for the pickers); the state is shared by all codetables.
 */
export var useOnixOptions = function () {
    var codetablesQuery = useOnixCodetablesByNumbers(FORM_CODETABLE_NUMBERS);
    var tables = codetablesQuery.data;
    var status = toCodetableStatus(codetablesQuery);
    var loading = codetablesQuery.isLoading;
    var nameTypeTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.NAME_TYPE];
    var languageRoleTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.LANGUAGE_ROLE];
    var languageTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.LANGUAGE];
    var textContentTypeTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.TEXT_CONTENT_TYPE];
    var resourceTypeTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.RESOURCE_TYPE];
    var resourceModeTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.RESOURCE_MODE];
    var audienceTypeTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.AUDIENCE_TYPE];
    var subjectSchemeTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.SUBJECT_SCHEME];
    var primaryContentTypeTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.PRIMARY_CONTENT_TYPE];
    var formTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.PRODUCT_FORM];
    var formDetailTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.PRODUCT_FORM_DETAIL];
    var extentTypeTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.EXTENT_TYPE];
    var extentUnitTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.EXTENT_UNIT];
    var compositionTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.PRODUCT_COMPOSITION];
    var publishingStatusTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.PUBLISHING_STATUS];
    var priceTypeTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.PRICE_TYPE];
    var currencyTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.CURRENCY_CODE];
    var productRelationTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.PRODUCT_RELATION];
    var publisherRoleTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.PUBLISHER_ROLE];
    var unnamedPersonTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.UNNAMED_PERSON];
    var contributionRoleTable = tables === null || tables === void 0 ? void 0 : tables[ONIX_TABLES.CONTRIBUTION_ROLE];
    return {
        nameTypeTable: nameTypeTable,
        languageRoleTable: languageRoleTable,
        languageTable: languageTable,
        textContentTypeTable: textContentTypeTable,
        resourceTypeTable: resourceTypeTable,
        resourceModeTable: resourceModeTable,
        audienceTypeTable: audienceTypeTable,
        subjectSchemeTable: subjectSchemeTable,
        primaryContentTypeTable: primaryContentTypeTable,
        formTable: formTable,
        formDetailTable: formDetailTable,
        extentTypeTable: extentTypeTable,
        extentUnitTable: extentUnitTable,
        compositionTable: compositionTable,
        publishingStatusTable: publishingStatusTable,
        priceTypeTable: priceTypeTable,
        currencyTable: currencyTable,
        productRelationTable: productRelationTable,
        publisherRoleTable: publisherRoleTable,
        unnamedPersonTable: unnamedPersonTable,
        contributionRoleTable: contributionRoleTable,
        nameTypeOptions: toSelectOptions(nameTypeTable === null || nameTypeTable === void 0 ? void 0 : nameTypeTable.onixCodetableItems),
        languageRoleOptions: toSelectOptions(languageRoleTable === null || languageRoleTable === void 0 ? void 0 : languageRoleTable.onixCodetableItems),
        languageOptions: toSelectOptions(languageTable === null || languageTable === void 0 ? void 0 : languageTable.onixCodetableItems),
        textContentTypeOptions: toSelectOptions(textContentTypeTable === null || textContentTypeTable === void 0 ? void 0 : textContentTypeTable.onixCodetableItems),
        resourceTypeOptions: toSelectOptions(resourceTypeTable === null || resourceTypeTable === void 0 ? void 0 : resourceTypeTable.onixCodetableItems),
        resourceModeOptions: toSelectOptions(resourceModeTable === null || resourceModeTable === void 0 ? void 0 : resourceModeTable.onixCodetableItems),
        audienceTypeOptions: toSelectOptions(audienceTypeTable === null || audienceTypeTable === void 0 ? void 0 : audienceTypeTable.onixCodetableItems),
        subjectSchemeOptions: toSelectOptions(subjectSchemeTable === null || subjectSchemeTable === void 0 ? void 0 : subjectSchemeTable.onixCodetableItems),
        primaryContentTypeOptions: toSelectOptions(primaryContentTypeTable === null || primaryContentTypeTable === void 0 ? void 0 : primaryContentTypeTable.onixCodetableItems),
        formOptions: toSelectOptions(formTable === null || formTable === void 0 ? void 0 : formTable.onixCodetableItems),
        formDetailOptions: toSelectOptions(formDetailTable === null || formDetailTable === void 0 ? void 0 : formDetailTable.onixCodetableItems),
        extentTypeOptions: toSelectOptions(extentTypeTable === null || extentTypeTable === void 0 ? void 0 : extentTypeTable.onixCodetableItems),
        extentUnitOptions: toSelectOptions(extentUnitTable === null || extentUnitTable === void 0 ? void 0 : extentUnitTable.onixCodetableItems),
        compositionOptions: toSelectOptions(compositionTable === null || compositionTable === void 0 ? void 0 : compositionTable.onixCodetableItems),
        publishingStatusOptions: toSelectOptions(publishingStatusTable === null || publishingStatusTable === void 0 ? void 0 : publishingStatusTable.onixCodetableItems),
        priceTypeOptions: toSelectOptions(priceTypeTable === null || priceTypeTable === void 0 ? void 0 : priceTypeTable.onixCodetableItems),
        currencyOptions: toSelectOptions(currencyTable === null || currencyTable === void 0 ? void 0 : currencyTable.onixCodetableItems),
        productRelationOptions: toSelectOptions(productRelationTable === null || productRelationTable === void 0 ? void 0 : productRelationTable.onixCodetableItems),
        publisherRoleOptions: toSelectOptions(publisherRoleTable === null || publisherRoleTable === void 0 ? void 0 : publisherRoleTable.onixCodetableItems),
        unnamedPersonOptions: toSelectOptions(unnamedPersonTable === null || unnamedPersonTable === void 0 ? void 0 : unnamedPersonTable.onixCodetableItems),
        contributionRoleOptions: toSelectOptions(contributionRoleTable === null || contributionRoleTable === void 0 ? void 0 : contributionRoleTable.onixCodetableItems),
        nameTypeLoading: loading,
        languageRoleLoading: loading,
        languageLoading: loading,
        textContentTypeLoading: loading,
        resourceTypeLoading: loading,
        resourceModeLoading: loading,
        audienceTypeLoading: loading,
        subjectSchemeLoading: loading,
        primaryContentTypeLoading: loading,
        formLoading: loading,
        formDetailLoading: loading,
        extentTypeLoading: loading,
        extentUnitLoading: loading,
        compositionLoading: loading,
        publishingStatusLoading: loading,
        priceTypeLoading: loading,
        currencyLoading: loading,
        productRelationLoading: loading,
        publisherRoleLoading: loading,
        unnamedPersonLoading: loading,
        contributionRoleLoading: loading,
        nameTypeStatus: status,
        languageRoleStatus: status,
        languageStatus: status,
        textContentTypeStatus: status,
        resourceTypeStatus: status,
        resourceModeStatus: status,
        audienceTypeStatus: status,
        subjectSchemeStatus: status,
        primaryContentTypeStatus: status,
        formStatus: status,
        formDetailStatus: status,
        extentTypeStatus: status,
        extentUnitStatus: status,
        compositionStatus: status,
        publishingStatusStatus: status,
        priceTypeStatus: status,
        currencyStatus: status,
        productRelationStatus: status,
        publisherRoleStatus: status,
        unnamedPersonStatus: status,
        contributionRoleStatus: status,
    };
};
